export default __webpack_public_path__ + "static/media/user-thumbnail.5bf9660a.png";